import { TmApiValidationError } from '@/core/error/transport/tmApiValidationError'

export class TmPhoneVerificationIncorrectCodeError extends TmApiValidationError {}
